import React from 'react'

const C_Language = () => {
  return (
    <div>
         {/* collapseOne */}
              <div className="accordion-item mb-2">
                <h2 className="accordion-header" id="headingOne">
                  <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button"
                    data-bs-toggle="collapse" data-bs-target="#collapseOne"
                    aria-expanded="false" aria-controls="collapseOne">
                    C Language, Logic Building, Data Structures and Algorithms
                    <span className="toggle-icon ms-auto"></span>
                  </button>
                </h2>
                <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionCourses">
                  <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>C language</strong>:
                    <ul>
                      <li>History & Introduction of C language</li>
                      <li>Installation of C</li>
                      <li>Introduction to First Program</li>
                      <li>Variables & Datatypes</li>
                      <li>Control Statements, Break, Continue, Goto</li>
                      <li>Working with Functions</li>
                      <li>C Math Functions, Enumeration ( enum )</li>
                      <li>Working with Arrays</li>
                      <li>Pointers</li>
                      <li>Strings</li>
                      <li>Structure & Union</li>
                      <li>File Handling</li>
                      <li>Internal Theory & Practical Exam</li>
                    </ul>

                    <strong>C-Logic Building</strong>:
                    <ul>
                      <li>Introduction to C and Basic I/O</li>
                      <li>Data Types, Operators, and Expressions</li>
                      <li>Conditional Statements (If-Else, Switch)</li>
                      <li>Loops (For, While, Do-While)</li>
                      <li>Nested Loops and Pattern Printing</li>
                      <li>Functions and Recursion</li>
                      <li>Arrays (1D, 2D, Multi)</li>
                      <li>Strings and String Manipulation</li>
                      <li>Structures and Unions</li>
                      <li>File Handling in C</li>
                      <li>Advanced Logic Problems</li>
                      <li>Mini Project (Choose One)</li>
                    </ul>

                    <strong>Data Structures & Algorithms</strong>:
                    <ul>
                      <li>Introduction to Data Structures & Complexity Analysis</li>
                      <li>Arrays and Pointer Basics</li>
                      <li>Multi-Dimensional Arrays & Matrix Operations</li>
                      <li>String Manipulation in C</li>
                      <li>Searching Algorithms</li>
                      <li>Sorting Algorithms (Part 1)</li>
                      <li>Sorting Algorithms (Part 2)</li>
                      <li>Introduction to Linked Lists</li>
                      <li>Doubly and Circular Linked Lists</li>
                      <li>Stack Data Structure</li>
                      <li>Queue Data Structure</li>
                      <li>Priority Queue & Deque</li>
                      <li>Introduction to Trees</li>
                      <li>Binary Search Tree (BST)</li>
                      <li>Balanced Trees & Heaps</li>
                      <li>Introduction to Graphs & Representations</li>
                      <li>Shortest Path Algorithms</li>
                      <li>Hashing and Hash Tables</li>
                      <li>Dynamic Programming Concepts</li>
                      <li>Final Project & Optimization Techniques</li>
                    </ul>
                  </div>
                </div>
              </div>
    </div>
  )
}

export default C_Language